module.exports = __webpack_public_path__ + "static/media/058.715d7568.jpg";